import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import {
	ClaimUsageIngestionErrorItem,
	ClaimUsageIngestionJobStatus,
	ClaimUsageIngestionProcessingDetailData,
	getClaimUsageIngestionErrorPresentation,
} from './claim-usage-ingestion.models';

@Component({
	selector: 'app-claim-usage-ingestion-processing-detail-dialog',
	styleUrls: [
		'./claim-usage-ingestion-processing-detail-dialog.component.scss',
	],
	templateUrl:
		'./claim-usage-ingestion-processing-detail-dialog.component.html',
})
export class ClaimUsageIngestionProcessingDetailDialogComponent {
	readonly emptyValue = 'Indisponível';

	constructor(
		@Inject(MAT_DIALOG_DATA)
		readonly data: ClaimUsageIngestionProcessingDetailData,
		private readonly dialogRef: MatDialogRef<ClaimUsageIngestionProcessingDetailDialogComponent>,
	) {}

	formatBytes(size: number): string {
		if (size < 1024) {
			return `${size} B`;
		}

		if (size < 1024 * 1024) {
			return `${(size / 1024).toFixed(1)} KB`;
		}

		return `${(size / (1024 * 1024)).toFixed(1)} MB`;
	}

	formatDate(value: string): string {
		return new Intl.DateTimeFormat('pt-BR', {
			day: '2-digit',
			hour: '2-digit',
			minute: '2-digit',
			month: '2-digit',
			year: 'numeric',
		}).format(new Date(value));
	}

	formatOptionalDate(value: string | null | undefined): string {
		return value ? this.formatDate(value) : this.emptyValue;
	}

	getErrorItemPresentation(error: ClaimUsageIngestionErrorItem): string {
		return getClaimUsageIngestionErrorPresentation(error);
	}

	getErrorLineLabel(error: ClaimUsageIngestionErrorItem): string {
		return error.rowNumber ? `Linha ${error.rowNumber}` : 'Linha -';
	}

	getPostProcessingErrorPresentation(): string {
		return getClaimUsageIngestionErrorPresentation(this.data.postProcessing);
	}

	getPostProcessingValue(
		value: number | string | null | undefined,
	): number | string {
		return value ?? this.emptyValue;
	}

	getStatusLabel(
		status: ClaimUsageIngestionJobStatus | null | undefined,
	): string {
		if (!status) {
			return this.emptyValue;
		}

		switch (status) {
			case ClaimUsageIngestionJobStatus.CREATED:
				return '-';
			case ClaimUsageIngestionJobStatus.QUEUED:
				return 'Na fila';
			case ClaimUsageIngestionJobStatus.PROCESSING:
				return 'Processando';
			case ClaimUsageIngestionJobStatus.COMPLETED:
				return 'Sucesso';
			case ClaimUsageIngestionJobStatus.PARTIALLY_COMPLETED:
				return 'Parcial';
			case ClaimUsageIngestionJobStatus.FAILED:
				return 'Falha';
			default:
				return this.emptyValue;
		}
	}

	onClose(): void {
		this.dialogRef.close();
	}

	shouldShowPostProcessingError(): boolean {
		return Boolean(
			this.data.postProcessing?.errorCode ||
				this.data.postProcessing?.errorSummary ||
				this.data.postProcessing?.errorMessage ||
				this.data.postProcessing?.error ||
				this.data.postProcessing?.finalStatus ===
					ClaimUsageIngestionJobStatus.FAILED,
		);
	}
}
